import { IStyle } from 'Styles';

export const styles: IStyle = {
  versioningDiv: {
    position: 'absolute',
    right: '3%',
    bottom: '-5%',
    color: '#999999',
    fontSize: 'small',
    fontFamily: 'Roboto',
    fontWeight: 'normal',
  },
  welcomeMainContainer: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  welcomeTextTitle: {
    fontWeight: 'bold',
  },
  welcomeTextContainer: {
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: 'Roboto',
  },
  RMLogoSvg: {
    marginLeft: '2%',
    marginRight: '2%',
    alignItems: 'center',
  },
  dashboardNewsAndHelp: {
    height: '100%',
    width: '100%',
    margin: '2% 0 0 2%',
  },
  linkSvg: {
    position: 'absolute',
    left: '5%',
    bottom: '5%',
    cursor: 'pointer',
  },
  svgStyle: {
    position: 'absolute',
    right: '1%',
    bottom: '1%',
  },
};
